import {get} from 'lodash';
import {useContext} from 'react';
import {ContextStores, StoreContext} from '../contexts/storeContext';

export const useStoresContext = (serviceType: string): ContextStores => {
  const context = useContext(StoreContext);
  const stores = get(context, serviceType);

  if (!stores) {
    throw new Error('Store not found in context');
  }

  return stores;
};
